import React from "react";
import logo from "../../assets/images/logo2.svg";

const Footer = () => {
	return (
		<footer>
			<p
				style={{
					fontSize: "14px",
				}}
			>
				تم التطوير بواسطة
				<a
					href="https://ejjadh.sa/"
					target="_blank"
					rel="noreferrer"
					className="mx-2"
				>
					<img src={logo} alt="Ejjadh" />
				</a>
				جميع الحقوق محفوظة &copy; {new Date().getFullYear()}
			</p>
		</footer>
	);
};

export default Footer;
